import type {NamedSetState} from 'app/gemStore/devtools';

import type {MediaBreakpointSlice} from './types';

export const createMediaBreakpointSlice = (set: NamedSetState<MediaBreakpointSlice>) => ({
    mediaBreakpoint: typeof window !== 'undefined' ? window.innerWidth : 0,
    setMediaBreakpoint: (mediaBreakpoint: number) => set({mediaBreakpoint}, false, 'mediaBreakpoint/setMediaBreakpoint'),
});
